import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { toRoman, toCssClass } from 'helpers'
import { getReadyReserves } from 'helpers/reserves'

import { MODIFIER_CLAN_LANDING } from 'containers/ClanLanding/components/ClanLandingReserves/constants'
import { MAX_BUILDING_LEVEL } from 'constants'

import styles from './Reserve.scss'

export default class Reserve extends React.Component {
    static defaultProps = {
        highlighted: false,
    }
    static propTypes = {
        type: PropTypes.string.isRequired,
        level: PropTypes.number.isRequired,
        reserves: PropTypes.arrayOf(PropTypes.object),
        highlighted: PropTypes.bool.isRequired,
        modifier: PropTypes.oneOf(['toolbar', MODIFIER_CLAN_LANDING]),
        playSound: PropTypes.func,
    }
    componentWillMount() {
        this.updateTimer(this.props.reserves)
    }
    componentWillUnmount() {
        if (this.timerId) clearTimeout(this.timerId)
    }
    componentWillReceiveProps(nextProps) {
        this.updateTimer(nextProps.reserves)
    }
    updateTimer(reserves) {
        if (!this.props.reserves) return

        if (this.timerId) clearTimeout(this.timerId)

        const now = Date.now()
        const upcomingReserve = reserves
            .filter(reserve => ((reserve.level === this.props.level) && (reserve.productionEnds !== null)))
            .sort((first, second) => (first.productionEnds - second.productionEnds))
            .find(reserve => (reserve.productionEnds >= now))

        if (upcomingReserve !== undefined) {
            this.timerId = setTimeout(() => {
                this.props.playSound && this.props.playSound()
                this.forceUpdate()
                this.updateTimer(reserves)
            }, (upcomingReserve.productionEnds - now))
        }
    }
    render() {
        const isClanLanding = this.props.modifier === MODIFIER_CLAN_LANDING
        const classNamesImage = classNames(
            styles.image,
            styles[`image__${toCssClass(this.props.type)}`], {
                [styles.image__elite] : this.props.level > MAX_BUILDING_LEVEL,
                [styles.image__clanLanding] : isClanLanding,
            }
        )

        let reservesCount
        if (this.props.reserves) {
            const readyReserves = getReadyReserves(this.props.reserves)
            const { highlighted } = this.props

            const originalLevel = (highlighted ? (this.props.level - 1) : this.props.level)
            reservesCount = readyReserves.filter(reserve => (
                (reserve.level === originalLevel)
            )).length
        }

        let counterGradient
        if (this.props.modifier === 'toolbar') {
            counterGradient = (
                <span className={styles.counterGradient}>
                    {reservesCount}
                </span>
            )
        }

        const classNamesBase = classNames(styles.base, {
            [styles.base__toolbar]: this.props.modifier === 'toolbar',
            [styles.base__clanLanding]: isClanLanding,
            [styles.base__highlighted]: this.props.highlighted,
        })

        return (
            <div className={classNamesBase}>
                <span className={styles.level}>
                    {toRoman(this.props.level)}
                    <span className={styles.levelGradient}>{toRoman(this.props.level)}</span>
                </span>
                <div className={styles.thumbnail}>
                    <div className={classNamesImage} />
                </div>
                {!isClanLanding &&
                    <span className={styles.counter}>
                        {reservesCount}
                        {counterGradient}
                    </span>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Reserve/Reserve.jsx